import { Component, OnInit } from '@angular/core';
import { TermsService } from '@foh/mcompany-setup/terms/terms.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {
 routeObs$: any;
 code : string ; 
 title : string ; 
 template : string ; 
  constructor(private termsService : TermsService,private activeRoute: ActivatedRoute) { }

  ngOnInit() {
      
      this.routeObs$ =  this.activeRoute.params.subscribe(
        (params)=> 
        {
            this.code  = params["code"];
            this.termsService.getByCode(this.code).subscribe( (response:any)=>
            {
                this.title = response.name;
                this.template = response.template;
                
            } );
         
         }
        );
      
  }

}
